import {
    serverBus
} from "@/main";
import Global from "@/scripts/Global";
import VueSignals from "@/scripts/VueSignals";

export default {
    name: 'ProgressBar',
    data() {
        return {
            uploadProgress: -1,
            upload_paused_ids: [],
            upload_file_id: '',
            upload_file_name: '',
            file_message_success: '',
            uploaded: 0,
            remaining: 0,
            min: 0,
            sec: 0,
        }
    },
    mounted() {
        serverBus.$on(VueSignals.UPDATE_UPLOAD_PROGRESS, (data) => {
            if (data.id == this.upload_file_id) {
                if (this.uploadProgress != data.progress) {
                    this.uploadProgress = data.progress
                }
                if (this.uploadProgress == 100) {
                    setTimeout(function() {
                        Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, data.id)
                    }, 3000)
                }
                if (this.uploaded != data.uploaded) {
                    if (typeof data.uploaded != 'undefined')
                        this.uploaded = data.uploaded.toFixed(2)
                }
                if (this.remaining != data.remaining) {
                    if (typeof data.uploaded != 'undefined')
                        this.remaining = data.remaining.toFixed(2)
                }
                if (this.min != data.min && !isNaN(data.min)) {
                    this.min = data.min
                }
                if (this.sec != data.sec && !isNaN(data.sec)) {
                    this.sec = data.sec
                }
            }
        })

        serverBus.$on(VueSignals.UPLOAD_PAUSED_ID, (upload_paused_id) => {
            if (this.upload_paused_ids.indexOf(upload_paused_id) < 0) {
                this.upload_paused_ids.push(upload_paused_id)
            } else {
                this.upload_paused_ids.splice(this.upload_paused_ids.indexOf(upload_paused_id), 1)
            }
        })


        serverBus.$on(VueSignals.REMOVE_PROGRESS_BAR, (upload_id) => {
            if (upload_id == this.upload_file_id) {
                this.uploadProgress = -1
            }
        })

        serverBus.$on(VueSignals.UPLOAD_FILE_DATA, (data) => {
            if (this.upload_file_id == data.id || this.upload_file_id == '') {
                this.upload_file_id = data.id
                this.upload_file_name = data.name
            }
        })
        document.querySelector("#chatPane").style.height = "calc(100vh - " + document.querySelector("#message_form").clientHeight + "px)"
    },
    methods: {
        PauseUpload: (upload_file_id) => {
            Global.globalValue(VueSignals.UPLOAD_PAUSED_ID, upload_file_id)
            Global.globalValue(VueSignals.SET_UPLOAD_PAUSED, upload_file_id)
        },
        CancelUpload: (upload_file_id, upload_file_name) => {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'confirm_upload_cancel')
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                "upload_id": upload_file_id,
                "upload_name": upload_file_name
            })
        },
        ContinueUpload: (upload_file_id) => {
            Global.globalValue(VueSignals.UPLOAD_PAUSED_ID, upload_file_id)
            Global.globalValue(VueSignals.SET_UPLOAD_CONTINUE, upload_file_id)
        }
    }

}
